import React, { Component } from "react";
import {
    withRouter
} from "react-router-dom";
import {
    Page,
    Text,
    Card,
    Button,
    ProgressBar,
    BlockStack,
    Tooltip,
    Banner,
    Badge,
    Icon,
    Modal,
    Spinner,
    Collapsible,
    Link,
    TextField,
    ChoiceList,
    Popover,
    ActionList,
    SkeletonBodyText,

} from "@shopify/polaris";
import {
    ChevronDownIcon,
    ChevronUpIcon,
    QuestionCircleIcon,
    MenuHorizontalIcon,
    DesktopIcon,
    MobileIcon,
    ArrowRightIcon,
    SelectIcon,
    SearchIcon,
} from "@shopify/polaris-icons";

import { store } from "../../../redux/store";
import "./index.scss";
import Switch from "react-switch";
import SpeedBasicIcon from '../../../assets/SpeedUp/SpeedBasicIcon.jsx';
import SpeedFastIcon from '../../../assets/SpeedUp/SpeedFastIcon.jsx';
import SpeedRocketIcon from '../../../assets/SpeedUp/SpeedRocketIcon.jsx';
import SuInstantPageIcon from '../../../assets/SpeedUp/SuInstantPageIcon.jsx';
import SuStreamlinedLoading from '../../../assets/SpeedUp/SuStreamlinedLoading.jsx';
import SuLazyLoading from '../../../assets/SpeedUp/SuLazyLoading.jsx';
import SuOptimizedLoading from '../../../assets/SpeedUp/SuOptimizedLoading.jsx';
import SuAssetsFileOptimization from '../../../assets/SpeedUp/SuAssetsFileOptimization.jsx';
import SuStreamlineCode from '../../../assets/SpeedUp/SuStreamlineCode.jsx';
import SettingsIcon from '../../../assets/SpeedUp/SettingsIcon.jsx';
// 翻译
import Language from "../../../i18n/Language";
import utils from "../../../utils/utils";
import cloneDeep from 'lodash-es/cloneDeep';
import {
    reqCopyThemeData,
    reqSpeedUpData,
    reqSpeedUpSetting,
    reqGetSpeedupRecord,
    reqUpSpeedUpSetting,
    reqStartSpeedUp,
    reqActionThemeData,
    reqRestartSpeedUp,
    reqCheckWebStatus,
    reqCloseSucPubBanner,
    reqRefreshPageOnline,
    reqGetPageSpeedOnlineStatus,
    reqGetThemeOptList,
    reqUpdGuideSteps,

} from "../../../api";
import { connect } from "react-redux";
import UpgradeModal from "../../../components/UpgradeModal";
import ViewImage from "../../../components/ViewImage/index.jsx";
import SkeltonLoading from "../../../components/SkeltonLoading/index.jsx";
import { setSaveSwitchData } from "../../../redux/actions/getAppPublicData.js";
import { setPageData } from "../../../redux/actions/getAppPageData.js";
import FooterTrustHelp from "../../../components/FooterTrustHelp/index.jsx";
import { showNewMessage } from '@intercom/messenger-js-sdk';
import InstrumentPanel from "../../../components/InstrumentPanel/index.jsx";
const t = Language;
let themeArr = [], recordArr = [], speedArr = [];
let currentAnimateIndex = 0;
let readFileNum = {
    current: 0,
    all: 0,
}
let readFileRecordId = null;
class SiteSpeedup extends Component {
    state = {
        showToast: false,
        showToastText: '',
        showToastIserror: '',
        loadingPage: true,
        planId: 1,                                          // 加速版本id
        isShowProgress: false,                              // 进度列表状态
        questionList: {
            high_score: {
                title: "What are the benefits of having a high Google Pagespeed score for a store?",
                tag: [
                    "Improved user experience: Faster load times can lead to a better user experience, making it easier for visitors to navigate and engage with your website.",
                    "Higher search engine rankings: Google considers page speed as a ranking factor in its search algorithm, so optimizing your website for faster load times can help improve its visibility in search results.",
                    "Competitive advantage: A faster website can give you a competitive advantage over other websites in your industry, as users are more likely to engage with a site that loads quickly and efficiently."
                ]
            },
            increase_in: {
                title: "What is the potential increase in score if I enable the Speed Up?",
                tag: ["It is difficult to determine the exact potential increase in score that can be achieved by enabling the Speed Up feature as it can vary depending on the website's current performance and optimization. However, enabling this feature can generally lead to improved loading times and overall performance."]
            },
            speed_theme: {
                title: "Will the speed optimization function change my theme code?",
                tag: [
                    "Some speed-up functions will insert code into your website and affect the theme, but don't worry, we provide a copy theme function, you can apply the function test on the copy theme"
                ]
            },
            use_feature: {
                title: "How do I use this feature?",
                tag: [
                    "We optimize your website speed through Preload Pages, Streamlined Loading, Asset File Optimization and other features. We recommend that you perform another website speed optimization after the initial website speed optimization and when your website content is updated."
                ]
            }
        }, // 问题列表
        serversList: [
            {
                id: 1,
                status: false,
                plan: 1,
                name: "Instant Page Load",
                title: "instant_page",
                func: [1, 1, 1],
                desc: "Preloads links before visitors click, making clicks feel instant and cutting wait time",
                copys: false,
                svg: SuInstantPageIcon,
                image: "/imgs/speedup/instant_page.png",
            },
            {
                id: 3,
                status: false,
                plan: 2,
                name: "Lazy Load Images",
                title: "lazy_loading",
                func: [0, 1, 1],
                desc: "Delay loading images until they appear on screen to improve speed and reduce data usage.",
                copys: false,
                svg: SuLazyLoading,
                image: "/imgs/speedup/img_lazy.png",
            },
            {
                id: 2,
                status: false,
                plan: 2,
                name: "Defer External Script",
                title: "streamline_loading",
                func: [0, 1, 1],
                desc: "Prioritizes your store's own resources while deferring non-essential third-party scripts.",
                copys: true,
                svg: SuStreamlinedLoading,
                image: "/imgs/speedup/js_lazy.png",
            },
            {
                id: 5,
                status: false,
                plan: 3,
                name: "Critical CSS Loading",
                title: "optimize_loading",
                func: [0, 0, 1],
                desc: "Loads critical CSS first and lazy-loads the rest to boost first paint speed.",
                copys: true,
                svg: SuOptimizedLoading,
                image: "/imgs/speedup/critical_css.png",
            },
            {
                id: 6,
                status: false,
                plan: 3,
                name: "Asset File Compression",
                title: "asset_file_optimize",
                func: [0, 0, 1],
                desc: "Compresses SVG and image files from the <Assets> resource to reduce file size and improve site performance.",
                copys: true,
                svg: SuAssetsFileOptimization,
                image: "/imgs/speedup/file_opt.png",
            },
            {
                id: 7,
                status: false,
                plan: 3,
                name: "Code Optimization",
                title: "streamline_code",
                func: [0, 0, 1],
                desc: "Removes unnecessary code from the <Assets> resource (spaces, line breaks, comments) to improve page speed.",
                copys: true,
                svg: SuStreamlineCode,
                image: "/imgs/speedup/code_opt.png",
            },
            {
                id: 8,
                status: false,
                plan: 3,
                name: "Lazy Load Video & Iframe",
                title: "video_lazy",
                func: [0, 0, 1],
                desc: "Delay the loading of embedded videos and Iframes until they are visible on screen.",
                copys: true,
                svg: SuLazyLoading,
                image: "/imgs/speedup/video_lazy.png",
            }
            // {
            //     id: 4,
            //     status: false,
            //     plan: 2,
            //     name: "Stable Loading",
            //     title: "stable_loading",
            //     func: [0, 1, 1],
            //     desc: "Hides the page's main content until it loads. Improves the Cumulative Layout Shift metric by stabilizing the page.",
            //     svg: SuStableLoading,
            // },
        ],
        popList: {
            "Instant Page Load": {
                img: "/imgs/speedup/instant_page.png",
                desc: "Preloads links before visitors click, making clicks feel instant and cutting wait time"
            },
            "Lazy Load Images": {
                img: "/imgs/speedup/img_lazy.png",
                desc: "Delay loading images until they appear on screen to improve speed and reduce data usage."
            },
            "Defer External Script": {
                img: "/imgs/speedup/js_lazy.png",
                desc: "Prioritizes your store's own resources while deferring non-essential third-party scripts."
            },
            "Critical CSS Loading": {
                img: "/imgs/speedup/critical_css.png",
                desc: "Loads critical CSS first and lazy-loads the rest to boost first paint speed."
            },
            "Asset File Compression": {
                img: "/imgs/speedup/file_opt.png",
                desc: "Compresses SVG and image files from the <Assets> resource to reduce file size and improve site performance."
            },
            "Code Optimization": {
                img: "/imgs/speedup/code_opt.png",
                desc: "Removes unnecessary code from the <Assets> resource (spaces, line breaks, comments) to improve page speed."
            },
            "Lazy Load Video & Iframe": {
                img: "/imgs/speedup/video_lazy.png",
                desc: "Delay the loading of embedded videos and Iframes until they are visible on screen."
            }
        },
        originServersList: [],
        isShowConfirmModal: false,                          // 加速确认状态
        isShowSettingPage: false,                           // 设置页面
        isShowPublicTip: false,                             // 发布主题提示弹窗
        level: 1,
        domain: "",                                         // 用户域名
        taskCpl: 0,                                         // 完成任务数量
        taskAll: 1,                                         // 全部任务数量
        isShowCompleteModal: false,                        // 是否显示优化完成banner
        isShowChooseTheme: false,                           // 选择主题弹窗
        isShowSuccessBanner: false,                         // 发布成功提示
        tabKey: 0,
        upgradeBtn: false,
        speedupCopyState: true,                               // 加速复制主题按钮状态
        speedupCopyLoading: false,                            // 加速复制主题按钮loading
        speedupThemeName: "",                                 // 加速主题名称
        copyThemeId: -1,                                      // 复制主题id
        themeList: [],                                        // 主题记录列表
        themeListLoading: true,                               // 主题记录列表loading
        selectThemeId: -1,                                    // 优化主题id
        isSwitch: -1,
        modalToPlan: false,                                   // 弹窗到版本
        upgradeModalShow: this.props.upgradeModalShow,
        imgUrl: '',
        recordList: [
            {
                id: 10,
                title: "read_all_files",
                SupStatus: 0,                                   // 0不优化 1优化完成 2优化中 3待优化
                pStatus: 0,
                tStatus: 0,                                     // 0未完成 1完成    动画状态
                do: "Read theme files",
                plan: 2,
                nums: {
                    current: 0,
                    all: 100,
                }
            },
            {
                id: 11,
                title: "instant_page",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Instant Page Load",
                plan: 1,
            },
            {
                id: 13,
                title: "lazy_loading",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Lazy Load Images",
                plan: 2,
            },
            {
                id: 12,
                title: "streamline_loading",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Defer External Script",
                plan: 2,
            },
            {
                id: 14,
                title: "streamline_code",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Code Optimization",
                plan: 3,
            },
            {
                id: 15,
                title: "asset_file_optimize",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Asset File Compression",
                plan: 3,
            },
            {
                id: 16,
                title: "optimize_loading",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Critical CSS Loading",
                plan: 3,
            },
            {
                id: 17,
                title: "video_lazy",
                SupStatus: 0,
                pStatus: 0,
                tStatus: 0,
                do: "Lazy Load Video & Iframe",
                plan: 3,
            },
        ],
        LastOptTime: '-',                                      // 上次优化时间
        isAllBtnFalse: false,                                  // 全部禁止
        publicBtnLoading: false,                               // 发布loading
        bannerSite: 'top',                                     // top || modal
        isShowErrorTip: false,
        isSetState: true,
        operaThemeId: -1,                                      // 操作的主题id
        operaThemeName: '',                                    // 操作的主题名称
        excessPlan: 1,                                         // 选中套餐需要的等级
        isOnlySpeedLoading: false,                             // 是否直接加速loading
        isShowSpedTip: true,                                   // 删除提示banner
        bf_theme: {},
        restoreListLoading: true,
        restoreThemeList: [],                                  // 恢复主题列表
        themeAppExtensionUrl: '',                              // 扩展链接
        startRestoreLoading: false,                            // 恢复按钮loading
        currentThemeId: -1,                                    // 当前主题id
        isTimeOut: false,                                      // 是否超时
        reoptLoading: false,                                   // 重新优化
        isPwd: true,                                         // 是否需要密码
        recordId: -1,                                          // 恢复id

        isShowSecTip: false,                                    // 新手引导状态
        isShowPop: false,
        isGuideTip: false,
        reduxLoading: true,
        uName: "",                                              // 用户名称
        isForbitSpeedup: false,                                // 是否禁止加速 300秒内不能加速
        performanceTab: 'pc',                                  // 性能指标tab
        RecheckButtonLoading: false,                             // 性能指标loading
        isShowSpeedupThemeModal: false,                        // 加速->主题 弹窗状态
        isNoneSTheme: false,                                   // 是否没有主题
        isShowCopyTheme: false,                                // 是否显示复制主题
        themeSelect: 'manual',                                  // 主题选择
        isShowThemeSelectPop: false,                            // 主题选择弹窗
        copyThemeListData: [],                                  // 复制主题列表数据
        themeSelectSearch: '',                                  // 主题选择搜索
        themeSelectName: '',                                    // 主题选择名称
        moreSelectId: -1,                                      // 更多选择id
        acceleratedThemeList: [],                               // 加速主题列表
        isShowCelebrateModal: false,                          // 庆祝弹窗 - 50%
        isShowCelebrateModal20: false,                          // 庆祝弹窗 - 20%
        scoreObj: {
            before_pc: 0,
            before_mb: 0,
            after_pc: 0,
            after_mb: 0,
        },
        isShowSpeedupProgressModule: false,                   // 是否显示加速进度模块
        optListLoading: true,                                  // 主题优化列表loading
        isMore: false,                                          // 是否显示更多
        isShowRemoveRecordConfirmModal: false,                  // 移除记录确认弹窗
        removeRecordThemeId: -1,                                     // 移除记录主题id
        removeLoading: false,                                      // 移除记录loading
        isShowProgressModule: false,                               // 是否显示加速进度模块
        deleteThemeLoading: false,                                // 删除主题loading
        isShowUpScore: false,                                   // 是否显示快速提升弹窗
        isShowScoreModule: false,                                 // 是否显示分数模块
        upPerc: 0,                                               // 分数提高百分比
        pc_upscore: 0,                                             // 电脑端分数提高
        mb_upscore: 0,                                             // 移动端分数提高
        animateList: [],
        isAnimating: false,
        isFakeBtnLoading: false,                                // 假按钮loading
        isFirstCopyTheme: false,
        isExistPublishTheme: false,                              // 是否存在发布的主题
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.upgradeModalShow !== this.props.upgradeModalShow) {
            // 判断是否二次弹窗
            if (!nextProps.upgradeModalShow && this.state.modalToPlan) {
                this.setState({
                    isShowConfirmModal: true,
                    modalToPlan: false,
                })
            }
        }

        return true;
    }

    componentDidMount() {
        const _params = this.props.location;
        let _store = store.getState().public;
        let _page = store.getState().page;
        let isShowSecTip = false;
        try {
            isShowSecTip = !Boolean(sessionStorage.getItem('speedupSecTip'));
        } catch (e) { }
        this.setState({
            level: _store.level,
            planId: _store.level,
            domain: _store.domain,
            uName: _store.publicInit?.shop_data.name,
            themeAppExtensionUrl: _store.homeStreamData.other_options?.seoant_core_url || '',

            isGuideTip: Boolean(_params?.query === "showPopover"),
            isShowSecTip,
        }, () => {
            this.checkWebsiteState();
            this.getSpeedupSetting(false, _page.pageInit.SiteSpeedUp);
            this.getSeoantThemeData();
            this.getThemeOptList();
        })
    }

    // 检测状态
    checkWebsiteState = async () => {
        const res = await reqCheckWebStatus();
        if (res.ack === 1) {
            this.setState({
                isPwd: res.data.status === 2 || res.data.is_password === 1,
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取主题优化列表
    getThemeOptList = async () => {
        const res = await reqGetThemeOptList();
        if (res.ack === 1) {
            // 添加发布主题
            let acceleratedThemeList = [];
            let mainTheme = res.data.filter(theme => {
                return theme.role === "main";
            });
            if (mainTheme.length > 0) {
                acceleratedThemeList.push(mainTheme[0]);
            }
            // 获取已优化的主题列表
            acceleratedThemeList.push(...res.data.filter(theme => {
                return !theme.is_del && theme.role !== "main";
            }));
            this.setState({
                acceleratedThemeList,
                optListLoading: false,
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取加速设置
    getSpeedupSetting = async (isGetTheme = false, _reduxData = null, isGetRecord = true, isComputeScore = false) => {
        let res = {};
        if (_reduxData?.SpeedUpSettings) {
            res = _reduxData.SpeedUpSettings;
        } else {
            res = await reqSpeedUpSetting();
        }
        if (res.ack === 1) {
            if (_reduxData?.SpeedUpSettings) {
                this.getSpeedupSetting(false, null);
            }
            this.props.getPageDataRedux({ 'SpeedUpSettings': res });
            let t_setting = res.data.setting;
            let t_score = res.data.speed_score;
            // 判断是否轮询
            if (t_score.status === 0) {
                this.getPageSpeedOnlineStatus();
            }
            let { serversList, isPwd, isExistPublishTheme } = this.state;
            let newList = cloneDeep(serversList);
            newList.forEach((item) => {
                item.status = Boolean(t_setting.switch[item.title]);
            })

            // 分数
            let before_pc = t_score.before_opt?.pc_score || 0;
            let before_mb = t_score.before_opt?.m_score || 0;
            let after_pc = t_score.pc_score || 0;
            let after_mb = t_score.m_score || 0;
            // 判断分数是否超预期
            if (!isPwd && isComputeScore && isExistPublishTheme) {
                let n_pc = after_pc - before_pc;
                let n_mb = after_mb - before_mb;
                // 分数提高
                if (before_pc < after_pc || before_mb < after_mb) {
                    let n_perc = (n_pc / before_pc) > (n_mb / before_mb) ? ((n_pc / before_pc) * 100).toFixed(0) : ((n_mb / before_mb) * 100).toFixed(0);
                    this.setState({
                        upPerc: n_perc,
                        isShowCelebrateModal: true,
                        isShowUpScore: true,
                        pc_upscore: n_pc,
                        mb_upscore: n_mb,
                    }, () => {
                        // 动效后展示分数模块
                        setTimeout(() => {
                            this.setState({
                                isShowScoreModule: true,
                            })
                        }, 3000)
                    })
                } else {
                    if (after_pc >= 50) {
                        this.setState({
                            isShowCelebrateModal: true,
                            isShowUpScore: false,
                            upPerc: after_pc >= 85 ? 90 : (after_pc >= 70 && after_pc < 85) ? 80 : (after_pc >= 50 && after_pc < 70) ? 60 : 50,
                        })
                    }
                }
            }

            this.setState({
                serversList: newList,
                originServersList: newList,
                bf_theme: t_setting.before_theme,
                LastOptTime: t_setting.last_opt_at || 0,
                currentThemeId: t_setting.theme.theme_id,
                scoreObj: {
                    before_pc,
                    before_mb,
                    after_pc,
                    after_mb,
                }
            }, () => {
                if (isGetRecord) {
                    this.getSpeedupRecord(_reduxData, true);
                }
                if (isGetTheme) {
                    this.getSeoantThemeData();
                }
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }

        return true;
    }

    // 获取优化记录
    getSpeedupRecord = async (_reduxData = null, isGetRecord = true) => {
        let res = {};
        if (_reduxData?.SpeedUpRecord) {
            res = _reduxData?.SpeedUpRecord;
        } else {
            res = await reqGetSpeedupRecord();
        }
        if (res.ack === 1) {
            this.props.getPageDataRedux({ 'SpeedUpRecord': res });
            let _t = res.data;
            let recordExits = Object.keys(_t).length > 0;   // 记录是否存在
            let isMoreThan = _t?.updated_at ? (((new Date().getTime()) / 1000 - _t.updated_at) > (30 * 60)) : false;
            // 工作流进入失败终态后立即停止轮询和动画，不能再依赖 opt_fun 的 2/3 判断。
            let isWorkflowFailed = Number(_t?.workflow_status) === 5 || Number(_t?.is_time_out) === 1;
            let { recordList, isShowProgress, animateList, isAnimating } = this.state;
            let optFun = _t?.opt_fun ? JSON.parse(_t.opt_fun) : {};
            // 获取设置状态
            let newList = cloneDeep(recordList);
            let supList = cloneDeep(animateList.length > 0 ? animateList : recordList);
            if (readFileRecordId !== _t.id) {
                // 同一主题再次优化会生成新记录；切换 record_id 时必须清空上一轮累计进度。
                readFileRecordId = _t.id;
                readFileNum = {
                    current: Number(_t.current_asset_num) || 0,
                    all: Number(_t.asset_num) || 0,
                }
            } else {
                readFileNum = {
                    current: Math.max(readFileNum.current, Number(_t.current_asset_num) || 0),
                    all: Math.max(readFileNum.all, Number(_t.asset_num) || 0),
                }
            }
            newList.forEach(item => {
                let objs = optFun[item.title] || 0;
                item.SupStatus = objs;
                item.pStatus = objs !== 1 ? objs : objs === 1 ? 1 : 0;
                item.tStatus = objs !== 1 ? objs : objs === 1 ? 1 : 0;
                if (item.title === "read_all_files") {
                    item.SupStatus = item.SupStatus === 1 ? item.SupStatus : _t.read_status;
                    item.pStatus = _t.read_status !== 1 ? _t.read_status : item.pStatus === 1 ? 1 : 0;
                    item.tStatus = _t.read_status !== 1 ? _t.read_status : item.tStatus === 1 ? 1 : 0;
                    item.nums = readFileNum;
                }

                supList.forEach(sitem => {
                    if (sitem?.title && sitem.title === item.title) {
                        sitem.SupStatus = objs;
                        if (objs !== 1 && sitem.title !== "read_all_files") {
                            sitem.pStatus = objs;
                            sitem.tStatus = objs;
                        }
                        if (sitem.title === "read_all_files") {
                            sitem.SupStatus = sitem.SupStatus === 1 ? sitem.SupStatus : _t.read_status;
                            sitem.nums = readFileNum;
                        }
                    }
                })
            })
            let hasState = newList.filter(i => i.title === "read_all_files" || i.SupStatus !== 0);
            let finishState = newList.filter(i => (i.title === "read_all_files" || i.SupStatus === 1));
            let tHasState = supList.filter(i => i.tStatus !== 0 && i.tStatus !== 1);
            // let tFinishState = supList.filter(i => i.tStatus === 1);
            let supFilterList = supList.filter(i => i.title === "read_all_files" || i.SupStatus !== 0);
            if (tHasState.length > 0 && !isWorkflowFailed) {
                this.setTransitionProgress(supFilterList); // 执行动画
            }
            this.setState({
                loadingPage: false,
                recordList: newList,
                isShowProgress: isWorkflowFailed ? false : (tHasState.length === 0 && recordExits) ? isShowProgress : true,
                isAllBtnFalse: isWorkflowFailed ? false : (tHasState.length > 0 && recordExits) ? true : false,
                // taskCpl: tFinishState.length,
                taskAll: hasState.length,
                operaThemeId: _t.theme_id,
                operaThemeName: _t.theme_name,
                isTimeOut: isWorkflowFailed || (isMoreThan && finishState.length !== hasState.length),
                recordId: _t.id,
                reduxLoading: Boolean(_reduxData?.SpeedUpRecord),
                animateList: isWorkflowFailed ? [] : supFilterList,
            }, () => {
                if (isWorkflowFailed) {
                    this.clearRecordGet();
                    this.setState({
                        isShowProgressModule: false,
                        isAnimating: false,
                    });
                    return;
                }
                // 判断是否全部执行完成
                if (Object.keys(_t).length > 0) {
                    if (finishState.length === hasState.length) {
                        this.setState({
                            isShowCompleteModal: !Boolean(_t?.is_close_banner) && !isAnimating,
                        }, () => {
                            if (!isGetRecord) {
                                this.getSpeedupSetting(false, null, false);
                            }
                            this.clearRecordGet(true);
                        })
                    } else {
                        this.setState({
                            isShowProgressModule: true,
                        })
                        // 继续轮询优化
                        if (recordArr.length === 0) {
                            let timer = setInterval(() => {
                                this.getSpeedupRecord();
                            }, 3000)
                            recordArr.push(timer);
                        }
                    }
                }

                // 动画过渡
                setTimeout(() => {
                    this.setState({ isShowPop: true })
                }, 200)
            })
        } else {
            this.setState({
                bannerSite: 'top',
            }, () => {
                this.setErrorBanner(res.msg);
            })
        }
    }

    // 设置动画（入口）
    setTransitionProgress = (data) => {
        const animateList = cloneDeep(data.filter(item => item.SupStatus !== 0));
        if (!animateList.length || this.state.isAnimating) return;
        // 动画执行
        this.setState({
            isAnimating: true,
        }, () => {
            this.runSequentialAnimation(0, animateList);
        })
    };

    // 顺序执行动画
    runSequentialAnimation = async (index, list) => {
        if (this.state.isTimeOut) return;
        if (index >= list.length) {
            currentAnimateIndex = 0;
            this.setState({
                isShowCompleteModal: true,
                isAnimating: false,
                isShowProgress: false,
                isAllBtnFalse: false,
                taskCpl: list.length,
            }, () => {
                this.getThemeOptList();
                setTimeout(() => {
                    // 隐藏进度模块
                    this.setState({
                        isShowProgressModule: false,
                    })
                }, 500)
            })
            return;
        }

        // Step 1: 标记为“正在执行动画”
        let { recordList, animateList } = this.state;
        let operaList = animateList.length > 0 ? animateList : recordList.filter(i => i.SupStatus !== 0);
        let notFinishLens = operaList.filter(i => i.title !== "read_all_files" && i.SupStatus !== 1).length;
        if (operaList.length > 0) {
            operaList.forEach(item => {
                recordList.forEach(ritem => {
                    if (item.title === ritem.title) {
                        item.SupStatus = ritem.SupStatus;
                        if (item.title === "read_all_files") {
                            item.SupStatus = notFinishLens === 0 ? 1 : ritem.SupStatus;
                            // 判断数量
                            if (item.nums.current < ritem.nums.current) {
                                readFileNum = ritem.nums;
                                item.nums = readFileNum;
                            }
                        }
                    }
                })
            })
        }
        const newList = cloneDeep(operaList);
        if (!newList.length) {
            setTimeout(() => {
                this.runSequentialAnimation(index, this.state.recordList.filter(i => i.SupStatus !== 0));
            }, 500);
            return;
        };
        newList[index].pStatus = newList[index]?.SupStatus || 0;
        this.setState({
            animateList: newList,
            taskCpl: index + 1,
        });

        // Step 2: 执行右滑 + 淡出动画（用 CSS 控制）
        await this.wait(1000);
        const updated = cloneDeep(newList);
        updated[index].tStatus = updated[index]?.SupStatus || 0;
        this.setState({ animateList: updated });

        // Step 3: 递归执行下一个
        await this.wait(1000);
        let nextInx = newList[index].tStatus === 1 ? index + 1 : index;
        currentAnimateIndex += newList[index].tStatus === 1 ? 1 : 0;
        this.runSequentialAnimation(nextInx, updated);
    };

    // 工具函数
    wait = (ms) => new Promise(res => setTimeout(res, ms));

    // 获取复制主题信息
    getCopyThemeData = async () => {
        const res = await reqCopyThemeData();
        if (res.ack === 1) {
            if (res.data?.previewable) {
                this.clearThemeGet(); // 清除
                this.setState({
                    speedupCopyState: false,
                    speedupCopyLoading: false,
                    copyThemeId: `${res.data.id}`,
                    speedupThemeName: res.data.name,
                    btnCopySupLoading: false,
                    selectThemeId: `${res.data.id}`,
                }, () => {
                    // 获取主题列表
                    this.getSeoantThemeData();
                })
            } else {
                if (Object.keys(res.data).length > 0) {
                    this.setState({
                        speedupCopyLoading: true,
                    })
                }
                if (themeArr.length === 0) {
                    let timer = setInterval(() => {
                        this.getCopyThemeData();
                    }, 6000)
                    themeArr.push(timer);
                }
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取主题记录
    getSeoantThemeData = async () => {
        const res = await reqSpeedUpData();
        if (res.ack === 1) {
            let copyThemeListData = this.handleCopyThemeListData(res.data, '');
            this.setState({
                themeList: res.data,
                restoreThemeList: [this.state.bf_theme, ...res.data],
                isNoneSTheme: res.data.length === 0,
                copyThemeListData,
                isExistPublishTheme: Boolean(copyThemeListData.filter(i => i.role === "main")?.length > 0)
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }

        this.setState({
            themeListLoading: false,
            restoreListLoading: false,
        })
    }

    // 格式 复制主题列表
    handleCopyThemeListData = (data, search = '') => {
        let newData = cloneDeep(data);
        if (search) {
            // 不区分大小写
            search = search.toLowerCase();
            newData = newData.filter(item => item.name.toLowerCase().includes(search));
        }

        // 把main主题放到最后面
        newData = newData.sort((a, b) => {
            if (a.role === "main") {
                return 1;
            } else if (b.role === "main") {
                return -1;
            }
            return 0;
        });

        return newData;
    }

    // 选择优化主题
    handleSelectTheme = (id, isDel) => {
        let { themeList } = this.state;
        if (isDel === 0) {
            this.setState({
                selectThemeId: id,
                themeSelectName: themeList.find(item => item.theme_id === id)?.name,
                isShowThemeSelectPop: false,
            })
        }
    }

    // 弹窗服务开关
    handleChangeModalSwitch = (data) => {
        let { level, serversList } = this.state;
        // 判断版本升级
        if (!data.status && ((data.plan > 1 && level === 1) || (data.plan > 2 && level <= 2))) {
            let e = data.plan === 2 ? 1 : 2;
            let type = e === 2 ? 'SpeedUpPre' : 'SpeedUpPro';
            this.props.upgradeModal(e, type, 'speed_up');
            this.setState({
                isShowConfirmModal: false,
                modalToPlan: true,
            })
        } else {
            let newList = cloneDeep(serversList);
            newList.forEach(item => {
                if (item.id === data.id) {
                    item.status = !Boolean(item.status);
                }
            })
            this.setState({
                excessPlan: this.getSetNeedPlan(newList),
                serversList: newList,
            })
        }
    }

    // 更新开关数据
    updateSwitchData = async (all, type = 'setting') => {
        let objs = {
            switch: {}
        }
        all.forEach(item => {
            objs.switch[item.title] = Number(Boolean(item.status));
        })
        const res = await reqUpSpeedUpSetting(objs);
        if (res.ack === 1) {
            // this.props.toggleToast(res.msg);
            if (type === 'modal') {
                this.setState({
                    isShowConfirmModal: false,
                    isOnlySpeedLoading: false,
                }, () => {
                    // 包含复制主题功能才弹窗
                    let operaThemeMode = this.verifyCopyTheme();
                    if (operaThemeMode === 2) {
                        this.handleChangeSpeedThemeModal(true)
                    } else {
                        if (operaThemeMode === 1) {
                            this.props.toggleToast(t("success"));
                        } else {
                            this.props.toggleToast(t("Speed Up Successful"));
                        }
                    }
                    this.getSpeedupSetting();
                })
            }
        } else {
            this.setState({
                bannerSite: 'modal',
                isOnlySpeedLoading: false,
            }, () => {
                this.setErrorBanner(res.msg);
            })
        }
        if (res) {
            this.setState({
                isSwitch: -1
            })
        }
    }

    // 选择加速版本
    handleSelectPlan = (e) => {
        this.setState({
            planId: e
        })
    }

    // 展开隐藏
    toggleProgressList = () => {
        let { isShowProgress } = this.state;
        this.setState({
            isShowProgress: !isShowProgress,
        })
    }

    // 版本比较弹窗
    toggleCompareModal = () => {
        let { level } = this.state;
        // 弹层样式
        this.props.changePopoverCss(true);
        this.setState({
            upgradeBtn: level === 1 ? 'pro' : level === 2 ? 'pre' : 'all',
        })
    }

    // 加速确认弹窗
    toggleComfirmModal = (states) => {
        // 判断哪些服务开启
        let _state = Boolean(states);
        let { isGuideTip } = this.state;
        let { LastOptTime } = this.state;
        let now = Math.floor(new Date().getTime() / 1000);
        // 弹层样式
        this.props.changePopoverCss(states);
        if (!states) {
            // 还原设置
            let { originServersList } = this.state;
            this.setState({
                serversList: originServersList,
            })
        }
        this.setState({
            isForbitSpeedup: (now - LastOptTime) < 1800,
            isShowConfirmModal: Boolean(_state),
            isShowSecTip: false,
        }, () => {
            this.clearErrorBanner();
            if (isGuideTip) {
                try {
                    sessionStorage.setItem("speedupSecTip", "close");
                } catch (e) { }
            }
        })
    }

    // 获取当前需要的版本
    getSetNeedPlan = (data) => {
        let datas = data.filter(i => i.status);
        let excessPlanArr = datas.map(i => {
            return i.plan;
        })
        return excessPlanArr.length === 0 ? 1 : Math.max(...excessPlanArr);
    }

    // 打开设置
    openSettingPage = () => {
        this.setState({
            isShowSettingPage: true,
        })
    }

    // 切换版本id
    changePlanId = (id, e) => {
        let { isAllBtnFalse } = this.state;
        if (!isAllBtnFalse) {
            let endId = id;
            if (e?.nativeEvent) {
                let width = e?.target.offsetWidth || 0;
                let clickRange = e.nativeEvent.offsetX;
                endId = (clickRange <= (width / 4)) ? 1 : (clickRange > (width / 4) && clickRange <= ((width / 4) * 3)) ? 2 : 3;
            }
            this.setState({
                planId: endId,
            })
        }
    }

    // 设置弹窗状态
    setSupCompleteModal = () => {
        this.setState({
            isShowCompleteModal: false
        }, async () => {
            const params = { record_id: this.state.recordId };
            const res = await reqCloseSucPubBanner(params);
            if (res) {
                this.getSpeedupSetting();
                this.getSpeedupRecord();
            }
        })
    }

    // 开始发布主题
    publishThemeData = (type = 1, themeId = null) => {
        if (type === 1) {
            this.setState({
                publicBtnLoading: themeId,
            }, () => {
                this.startPublishTheme("publish", themeId)
            })
        } else {
            this.setState({
                isShowRestoreListModal: true,
                restoreListLoading: true,
            }, () => {
                this.getSeoantThemeData();
            })
        }
    }

    // 发布主题发起  publish|restore
    startPublishTheme = async (action, themeId = null) => {
        let params = {
            action,
            theme_id: themeId
        }
        const res = await reqActionThemeData(params);
        if (res.ack === 1) {
            this.props.toggleToast(res.msg);
            this.setState({
                isShowPublicTip: false,
                isShowCompleteModal: false,
                publicBtnLoading: false,
                optListLoading: true,
                RecheckButtonLoading: true,
            }, () => {
                this.getThemeOptList();
                this.getSpeedupSetting(true);
            })
        } else {
            this.setState({
                publicBtnLoading: false,
                bannerSite: 'modal'
            }, () => {
                this.setErrorBanner(res.msg);
            })
        }
    }

    // 跳转主题
    GotoTheme = () => {
        let { uName, copyThemeListData } = this.state;
        window.open(`https://${uName}/admin/themes`);
        this.setState({
            isFirstCopyTheme: copyThemeListData.length > 0 ? false : true,
        }, () => {
            setTimeout(() => {
                this.getCopyThemeData();
            }, 1000)
        })
    }

    // 开始优化复制主题
    SpeedupCopyTheme = (type = '') => {
        let { copyThemeId, selectThemeId, serversList } = this.state;
        // 判断主题是否有效
        if (((type === 'copy' && (!copyThemeId || copyThemeId === -1)) || (type === 'opt' && (!selectThemeId || selectThemeId === -1)))) {
            this.props.toggleToast(t("The theme id is invalid"), true);
        } else {
            currentAnimateIndex = 0;
            this.setState({
                btnCopySupLoading: true,
                animateList: [],
            }, async () => {
                let switchData = {};
                serversList.forEach(item => {
                    switchData[item.title] = Number(Boolean(item.status));
                })
                let params = {
                    theme_id: type === 'copy' ? copyThemeId : selectThemeId,
                    switch: switchData,
                }
                const res = await reqStartSpeedUp(params);
                if (res.ack === 1) {
                    this.changeFinishState();
                    this.props.toggleToast(res.msg);
                    this.setState({
                        isShowSuccessBanner: false,
                        isShowCompleteModal: false,
                        isShowPublicTip: false,
                        btnCopySupLoading: false,
                        isShowChooseTheme: false,
                        isAllBtnFalse: true,
                        selectThemeId: -1,
                        tabKey: 0,
                        speedupThemeName: '',
                        speedupCopyLoading: false,
                        isShowSpeedupThemeModal: false,
                        themeSelect: 'manual',
                        isShowThemeSelectPop: false,
                        isFirstCopyTheme: false,
                    }, () => {
                        this.getSpeedupSetting();
                        if (recordArr.length === 0) {
                            this.getSpeedupRecord();
                            let timer = setInterval(() => {
                                this.getSpeedupRecord();
                            }, 3000)
                            recordArr.push(timer);
                        }
                    })
                } else {
                    this.setState({
                        btnCopySupLoading: false,
                        isAllBtnFalse: false,
                        bannerSite: this.state.isShowSpeedupThemeModal ? 'modal' : 'top',
                        selectThemeId: -1,
                        themeSelectName: '',
                    }, () => {
                        this.setErrorBanner(res.msg);
                    })
                }
            })
        }
    }

    // 加速主题
    handleSpeedUpTheme = (theme_id) => {
        this.setState({
            selectThemeId: theme_id,
            moreSelectId: -1,
        }, async () => {
            let operaThemeMode = this.verifyCopyTheme();
            if (operaThemeMode === 1) {
                this.setState({
                    selectThemeId: -1,
                    moreSelectId: -1,
                }, () => {
                    this.toggleComfirmModal(true)
                })
            } else if (operaThemeMode === 2) {
                this.SpeedupCopyTheme('opt');
            } else {
                setTimeout(() => {
                    this.setState({
                        selectThemeId: -1,
                    }, () => {
                        this.props.toggleToast(t("Speed Up Successful"));
                    })
                }, 1000)
            }
        })

    }

    // 判断是否需复制主题
    verifyCopyTheme = () => {
        let { serversList } = this.state;
        let openObjs = serversList.filter(item => item.status).map(name => name.title);
        return openObjs.length === 0 ? 1 : !(openObjs.every(v => ["instant_page", "lazy_loading"].includes(v))) ? 2 : 0;
    }

    // 预览
    openViewImage = (url) => {
        this.setState({
            imgUrl: url
        })
    }

    // 关闭弹窗
    changeUpgradeState = () => {
        // 弹层样式
        this.props.changePopoverCss(false);
        this.setState({
            upgradeBtn: false
        })
    }

    // 清除定时器
    clearThemeGet = () => {
        themeArr.map(timer => {
            clearInterval(timer);
            themeArr.pop();
            return false;
        })
    }

    // 清除记录定时器
    clearRecordGet = () => {
        recordArr.map(timer => {
            clearInterval(timer);
            recordArr.pop();
            return false;
        })
    }

    // 清空错误banner定义
    clearErrorBanner = () => {
        this.setState({
            bannerSite: '',
            isShowErrorTip: '',
            isSetState: true
        })
    }

    // 设置错误banner
    setErrorBanner = (res, cState = true) => {
        window.scrollTo(0, 0);
        this.setState({
            isShowErrorTip: res,
            isSetState: cState
        })
    }

    // 返回
    goBack = () => {
        // 判断是否加入设置页面
        let { isShowSettingPage } = this.state;
        if (isShowSettingPage) {
            this.setState({
                isShowSettingPage: false,
            })
        } else {
            utils.routeJump(this, "/speedOpt")
        }
    }

    //点击联系客服
    handleContactService = async () => {
        try {
            showNewMessage()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 关闭
    closeImageShow = () => {
        this.setState({
            imgUrl: ''
        })
    }

    // 设置性能指标tab
    handleSetPerformanceTab = (tab) => {
        this.setState({
            performanceTab: tab,
        })
    }

    // 重新检查性能指标
    handleRecheckPerformance = () => {
        this.setState({
            RecheckButtonLoading: true
        }, async () => {
            const res = await reqRefreshPageOnline();
            if (res?.ack === 1) {
                this.getPageSpeedOnlineStatus();
            } else {
                this.props.toggleToast(res.msg, true);
            }
        })
    }

    // 获取状态
    getPageSpeedOnlineStatus = async () => {
        const res = await reqGetPageSpeedOnlineStatus();
        if (res.ack === 1) {
            // 判断是否轮询
            if (res.data?.status !== 1) {
                this.setState({
                    RecheckButtonLoading: true,
                    isResetPageSpeed: true,
                }, () => {
                    if (speedArr.length === 0) {
                        let timer = setInterval(() => {
                            this.getPageSpeedOnlineStatus();
                        }, 10000)
                        speedArr.push(timer);
                    }
                })
            } else {
                this.setState({
                    RecheckButtonLoading: false,
                }, () => {
                    this.clearSpeedArray();
                    // 重新获取分数
                    this.getSpeedupSetting(false, null, true, true);
                })
            }
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 重新发起优化
    restartOptFunc = (e) => {
        e.stopPropagation();
        let { isTimeOut } = this.state;
        if (isTimeOut) {
            this.setState({
                reoptLoading: true
            }, async () => {
                const res = await reqRestartSpeedUp();
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg);
                    this.setState({
                        isTimeOut: false,
                        reoptLoading: false
                    }, () => {
                        this.getSpeedupRecord();
                    })
                } else {
                    this.setState({
                        reoptLoading: false,
                        bannerSite: 'top',
                    }, () => {
                        this.setErrorBanner(res.msg);
                    })
                }
            })
        }
    }

    // 加速->主题 弹窗状态
    handleChangeSpeedThemeModal = (state) => {
        let operaThemeMode = this.verifyCopyTheme();
        if (operaThemeMode === 1) {
            this.toggleComfirmModal(true)
        } else if (operaThemeMode === 2) {
            this.setState({
                isShowThemeSelectPop: false,
                isShowSpeedupThemeModal: state,
                moreSelectId: -1,
                themeSelect: 'manual',
                isShowErrorTip: '',
                bannerSite: 'top',
                selectThemeId: -1,
                themeSelectName: '',
                themeSelectSearch: '',
            }, () => {
                if (!state) {
                    this.setState({
                        isFirstCopyTheme: false,
                        speedupThemeName: '',
                    })
                    this.clearThemeGet();
                }
            })
        } else {
            this.changeFinishState();
            this.setState({
                isFakeBtnLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isFakeBtnLoading: false,
                    }, () => {
                        this.props.toggleToast(t("Speed Up Successful"));
                    })
                }, 1000)
            })
        }
    }

    // 选择主题模式
    handleSelectThemeMode = (mode) => {
        this.setState({
            themeSelect: mode,
        })
    }

    // 切换主题选择弹窗
    toggleThemeSelectPop = () => {
        this.setState({
            isShowThemeSelectPop: !this.state.isShowThemeSelectPop,
        })
    }

    // 解锁更多
    handleUpgradeMore = () => {
        this.setState({
            isShowConfirmModal: false,
            modalToPlan: true,
        }, () => {
            this.props.upgradeModal(2, 'SpeedUpPre', 'speed_up');
        })
    }

    // 主题选择搜索
    handleSearchThemeSelect = (value) => {
        let { themeList } = this.state;
        let copyThemeListData = this.handleCopyThemeListData(themeList, value);
        this.setState({
            themeSelectSearch: value,
            copyThemeListData
        })
    }

    // 更多功能选择
    handleMoreFuncSelect = (id) => {
        let { moreSelectId } = this.state;
        this.setState({
            moreSelectId: moreSelectId === id ? -1 : id
        })
    }

    // 切换庆祝弹窗
    toggleCelebrateModal = () => {
        this.setState({
            isShowCelebrateModal: !this.state.isShowCelebrateModal
        })
    }

    // 切换加速进度模块
    toggleSpeedupProgressModule = () => {
        this.setState({
            isShowSpeedupProgressModule: !this.state.isShowSpeedupProgressModule
        })
    }

    // 移除记录
    handleRemoveRecord = (theme_id) => {
        this.setState({
            isShowRemoveRecordConfirmModal: true,
            removeRecordThemeId: theme_id,
            moreSelectId: -1,
        })
    }

    // 更新加速设置
    handleUpdSpeedSetting = () => {
        this.setState({
            isOnlySpeedLoading: true
        }, () => {
            let { serversList } = this.state;
            this.updateSwitchData(serversList, 'modal');
        })
    }

    // 关闭移除记录确认弹窗
    handleCloseRemoveModal = () => {
        let { removeLoading } = this.state;
        if (removeLoading) {
            return;
        }
        this.setState({
            isShowRemoveRecordConfirmModal: false,
            removeRecordThemeId: -1,
            moreSelectId: -1,
        })
    }

    // 移除记录
    handleRemoveActRecord = () => {
        this.setState({
            removeLoading: true,
        }, async () => {
            let { removeRecordThemeId } = this.state;
            let params = {
                action: 'delete',
                theme_id: removeRecordThemeId
            }
            const res = await reqActionThemeData(params);
            if (res.ack === 1) {
                this.setState({
                    removeLoading: false,
                    isShowRemoveRecordConfirmModal: false,
                }, () => {
                    this.getThemeOptList();
                })
            } else {
                this.setState({
                    removeLoading: false,
                }, () => {
                    this.props.toggleToast(res.msg, true);
                })
            }
        })
    }

    // 关闭完成提示弹窗
    handleCloseCompleteModal = () => {
        this.setState({
            isShowCompleteModal: false,
        })
    }

    // 改变完成状态
    changeFinishState = async () => {
        // 判断是否已经完成
        let _aiGuide = store.getState().public.publicInit?.guide_steps || [];
        if (_aiGuide?.length === 0 || (_aiGuide?.length > 0 && _aiGuide?.find(i => i.step_key === "speed_up")?.is_completed === 1)) {
            return;
        }
        // 更新状态
        const params = {
            step_key: "speed_up",
            position: "home_page",
        }
        await reqUpdGuideSteps(params);
    }

    // 右侧面板鼠标进入
    handleRightMouseEnter = () => {
        this.props.changePopoverCss(true);
    }
    // 右侧面板鼠标离开
    handleRightMouseLeave = () => {
        this.props.changePopoverCss(false);
    }

    // 清除定时器
    clearSpeedArray = () => {
        speedArr.map(timer => {
            clearInterval(timer);
            speedArr.pop();
            return false;
        })
    }

    componentWillUnmount() {
        this.clearThemeGet();
        this.clearRecordGet();
        this.clearSpeedArray();
    }

    render() {
        const {
            loadingPage,
            planId,
            isShowProgress,
            isShowConfirmModal,
            serversList,
            level,
            taskCpl,
            taskAll,
            isShowCompleteModal,
            upgradeBtn,
            speedupCopyLoading,
            speedupThemeName,
            selectThemeId,
            imgUrl,
            btnCopySupLoading,
            isAllBtnFalse,
            publicBtnLoading,
            isShowErrorTip,
            isSetState,
            bannerSite,
            operaThemeId,
            domain,
            isOnlySpeedLoading,
            currentThemeId,
            isPwd,

            isShowSecTip,
            isShowPop,
            isGuideTip,
            reduxLoading,
            performanceTab,
            isShowSpeedupThemeModal,
            isNoneSTheme,
            themeSelect,
            isShowThemeSelectPop,
            copyThemeListData,
            themeSelectSearch,
            themeSelectName,
            moreSelectId,
            acceleratedThemeList,
            isShowCelebrateModal,
            scoreObj,
            optListLoading,
            isMore,
            isShowRemoveRecordConfirmModal,
            removeLoading,
            isShowProgressModule,
            isShowUpScore,
            isShowScoreModule,
            upPerc,
            pc_upscore,
            mb_upscore,
            animateList,
            isFakeBtnLoading,
            isFirstCopyTheme,
            RecheckButtonLoading,
            popList,
        } = this.state;

        // 判断是否shopify内嵌模式
        // const shopifyMode = store.getState().public.isShowTopMenu || 1;

        // 火箭icon
        const RocketIcon = <svg width="41" height="22" viewBox="0 0 41 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2C14 0.89543 14.8954 0 16 0H24C26.2091 0 28 1.79086 28 4V5C28 6.10457 27.1046 7 26 7H16C14.8954 7 14 6.10457 14 5V2Z" fill="url(#paint0_linear_21517_101330)" />
            <path d="M14 20C14 21.1046 14.8954 22 16 22H24C26.2091 22 28 20.2091 28 18V17C28 15.8954 27.1046 15 26 15H16C14.8954 15 14 15.8954 14 17V20Z" fill="url(#paint1_linear_21517_101330)" />
            <path d="M13 17C5.87134 17 2.93577 14.7405 2.51622 14.0476C2.18074 13.4934 2.79568 13.0162 3.35481 12.8472C1.55606 12.8472 1.11788e-09 11.75 1.11813e-09 11C-0.000102381 10.25 1.97553 9.15283 3.77427 9.15283C3.21514 8.98377 2.18074 8.50664 2.51622 7.95239C2.93577 7.25947 5.87134 5 13 5V17Z" fill="url(#paint2_linear_21517_101330)" />
            <path d="M12 6C12 4.89543 12.8954 4 14 4H27.3497C31.7491 4 35.9599 5.78616 39.0176 8.94927C40.1232 10.0929 40.1232 11.9071 39.0176 13.0507C35.96 16.2138 31.7491 18 27.3497 18H14C12.8954 18 12 17.1046 12 16V6Z" fill="url(#paint3_linear_21517_101330)" />
            <path d="M17.6221 7L19.2354 9.72656H19.2979L20.9189 7H22.8291L20.3877 11L22.8838 15H20.9385L19.2979 12.2695H19.2354L17.5947 15H15.6572L18.1611 11L15.7041 7H17.6221ZM23.7314 13.5938V12.2617L27.0713 7H28.2197V8.84375H27.54L25.4346 12.1758V12.2383H30.1807V13.5938H23.7314ZM27.5713 15V13.1875L27.6025 12.5977V7H29.1885V15H27.5713Z" fill="transparent" />
            <defs>
                <linearGradient id="paint0_linear_21517_101330" x1="14" y1="1.94444" x2="28" y2="1.94444" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF724B" />
                    <stop offset="1" stopColor="#FFD7BA" />
                </linearGradient>
                <linearGradient id="paint1_linear_21517_101330" x1="14" y1="20.0556" x2="28" y2="20.0556" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF724B" />
                    <stop offset="1" stopColor="#FFD7BA" />
                </linearGradient>
                <linearGradient id="paint2_linear_21517_101330" x1="13" y1="11" x2="0" y2="11" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFD470" />
                    <stop offset="1" stopColor="#FFF9DE" />
                </linearGradient>
                <linearGradient id="paint3_linear_21517_101330" x1="31.5" y1="11" x2="12" y2="11" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#4167FF" />
                    <stop offset="1" stopColor="#D0E6FF" />
                </linearGradient>
            </defs>
        </svg>

        // 检查图标
        const checkIcon = <svg width="24" height="24" viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fillRule="evenodd" d="M14.03 7.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 3.97-3.97a.75.75 0 0 1 1.06 0Z"></path></svg>

        // 错误banner
        const errorBannerBox = isShowErrorTip && <div>
            <Banner
                title={t(isShowErrorTip)}
                tone={isSetState ? "critical" : "warning"}
                onDismiss={this.clearErrorBanner}
                action={{
                    content: t("Contact us"),
                    onAction: this.handleContactService
                }}
            >
            </Banner>
        </div>

        // 移除记录确认弹窗
        const removeRecordConfirmModal = <Modal
            open={isShowRemoveRecordConfirmModal}
            title={t("Remove this theme from the optimization history?")}
            primaryAction={
                {
                    content: t("Remove"),
                    onAction: this.handleRemoveActRecord,
                    loading: removeLoading,
                }
            }
            secondaryActions={[{
                content: t("Cancel"),
                onAction: this.handleCloseRemoveModal,
                disabled: removeLoading,
            }]}
            onClose={this.handleCloseRemoveModal}
        >
            <Modal.Section>
                <Text variant="bodyMd" as="p">{t("This will only remove the theme from your Theme Optimization history — it won't delete it from Shopify.")}</Text>
            </Modal.Section>
        </Modal>

        // 庆祝弹窗
        const upScoreIcon = <svg width="63" height="29" viewBox="0 0 63 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M55 0C59.4183 0 63 3.58172 63 8V16C63 20.4183 59.4183 24 55 24H34.4639L31.8223 27.8135C31.4246 28.3875 30.5754 28.3875 30.1777 27.8135L27.5361 24H8C3.58172 24 0 20.4183 0 16L0 8C0 3.58172 3.58172 0 8 0L55 0Z" fill="url(#paint0_linear_99_14103)" />
            <path d="M15.1292 5.36791C15.9038 7.55842 17.5543 9.28573 19.6475 10.0963L19.999 10.2326L19.6475 10.3688C18.9683 10.6318 18.3358 10.9913 17.7646 11.4318C16.6326 12.3048 16.1763 13.732 15.7933 15.1093C14.8034 18.6693 13.0072 20 9.99902 20C12.4864 19.5267 13.439 17.6621 13.6905 15.5315C13.8899 13.8419 13.2441 12.0936 11.8329 11.1433C11.3712 10.8324 10.8748 10.5718 10.3506 10.3688L9.99902 10.2326L10.3506 10.0963C12.4437 9.28573 14.0943 7.55842 14.8688 5.36791L14.999 5L15.1292 5.36791Z" fill="url(#paint1_linear_99_14103)" />
            <defs>
                <linearGradient id="paint0_linear_99_14103" x1="-20.5" y1="2.5" x2="63" y2="2.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#8DD247" />
                    <stop offset="1" stopColor="#1FBE5F" />
                </linearGradient>
                <linearGradient id="paint1_linear_99_14103" x1="14.999" y1="5" x2="14.999" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.6" />
                </linearGradient>
            </defs>
        </svg>
        const celebrateModal = <Modal
            open={isShowCelebrateModal}
            title={isShowUpScore ? t("Your website is faster now 🚀") : t("Site speed boost completed!")}
            primaryAction={
                {
                    content: t("Got it"),
                    onAction: this.toggleCelebrateModal,
                }
            }
            onClose={this.toggleCelebrateModal}
        >
            <Modal.Section>
                {
                    isShowUpScore ? <div className="celebrate_modal_content">
                        {
                            !isShowScoreModule ? <>
                                <img src="/imgs/speedup/awesome.gif" alt="" />
                                <Text variant="headingMd" as="h2">{t("Awesome! Your website just got")} <span className="celebrate_perc">{upPerc}%</span> {t("faster")}.</Text>
                            </> : <div className="celebrate_modal_content_panel">
                                {
                                    pc_upscore > 0 ?
                                        <div>
                                            <div className="up_score_block">
                                                {upScoreIcon}
                                                <span>+{pc_upscore}</span>
                                            </div>
                                            <InstrumentPanel
                                                isSpeed={true}
                                                speedType={performanceTab}
                                                svgHeight={120}
                                                strokeDash={scoreObj.after_pc}
                                                strokeWidth={12}
                                                smallSize={0.3}
                                            />
                                            <p>{t("Desktop")}</p>
                                        </div> : null
                                }
                                {
                                    mb_upscore > 0 ?
                                        <div>
                                            <div className="up_score_block">
                                                {upScoreIcon}
                                                <span>+{mb_upscore}</span>
                                            </div>
                                            <InstrumentPanel
                                                isSpeed={true}
                                                speedType={performanceTab}
                                                svgHeight={120}
                                                strokeDash={scoreObj.after_mb}
                                                strokeWidth={12}
                                                smallSize={0.3}
                                            />
                                            <p>{t("Moblie")}</p>
                                        </div> : null
                                }
                            </div>
                        }
                    </div> : <div className="celebrate_modal_content">
                        <img src="/imgs/speedup/impre.gif" alt="" />
                        <BlockStack gap={100}>
                            <Text variant="headingMd" as="h2">
                                {
                                    scoreObj.after_pc >= 85 ? t("Impressive!")
                                        : scoreObj.after_pc >= 70 && scoreObj.after_pc < 85 ? t("Great!")
                                            : scoreObj.after_pc >= 50 && scoreObj.after_pc < 70 ? t("Good job!")
                                                : t("Impressive!")
                                }
                                &nbsp;
                                {t("Your website is faster than")} <span className="celebrate_perc">{upPerc}%</span> {t("of websites.")}
                            </Text>
                            <Text variant="bodyMd" as="p">
                                {t("Scores may fluctuate due to Google's test conditions. Temporary drops are normal.")}
                                &nbsp;
                                <Link removeUnderline external url="https://developer.chrome.com/docs/lighthouse/performance/performance-scoring">{t("Learn more")}.</Link>
                            </Text>
                        </BlockStack>
                    </div>
                }
            </Modal.Section>
        </Modal>

        // 付费版本比较弹窗
        const comparePlanModal = <UpgradeModal
            isCustomize={true}
            cusTitle={t("Compare Acceleration Options Across Plans")}
            cusServerList={serversList}
            upgradeModalShow={upgradeBtn}
            changeUpgradeState={this.changeUpgradeState}
            toggleToast={this.props.toggleToast}
            cwreportCustomBehavior={this.props.cwreportCustomBehavior}
            handleGetPlanSource={this.props.handleGetPlanSource}
        />

        // 加速->主题 弹窗
        const speedupThemeModal = <Modal
            open={isShowSpeedupThemeModal}
            title={t("Dupilicate Theme to Speed Up")}
            primaryAction={
                themeSelect === 'manual' && !Boolean(speedupThemeName) ? {
                    content: t("Duplicate Theme"),
                    onAction: this.GotoTheme,
                    loading: speedupCopyLoading,
                    disabled: btnCopySupLoading,
                } : {
                    content: t("Speed Up Now"),
                    disabled: selectThemeId === -1,
                    loading: btnCopySupLoading,
                    onAction: () => this.SpeedupCopyTheme(themeSelect === 'manual' ? 'copy' : 'opt')
                }
            }
            secondaryActions={[
                {
                    content: t("Cancel"),
                    onAction: () => this.handleChangeSpeedThemeModal(false),
                    disabled: btnCopySupLoading || speedupCopyLoading,
                }
            ]}
            onClose={() => this.handleChangeSpeedThemeModal(false)}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    {bannerSite === 'modal' && errorBannerBox}
                    {
                        (isNoneSTheme || isFirstCopyTheme) ? <div className="speedup_theme_modal_none">
                            <Text variant="bodyMd" as="p">{t("Speed optimization will modify your theme's code. Please duplicate theme first")}:</Text>
                            <div className="speedup_theme_modal_none_list">
                                <Text variant="bodyMd" as="p">1. {t("Click")} <Button variant="plain" disabled={Boolean(speedupThemeName)} onClick={this.GotoTheme}>{t("Duplicate Theme")}</Button> {t("in SEOWILL")}.</Text>
                                <Text variant="bodyMd" as="p">2. {t("Duplicate your desired theme in the Shopify Theme Section.")}</Text>
                                <Text variant="bodyMd" as="p">3. {t("Return to SEOWILL and click 'Speed Up Now'.")}</Text>
                            </div>
                            <img className="dup_gif" src="/imgs/speedup/speed_dup.gif" alt="" />
                            <div className="via_theme_block">
                                {
                                    Boolean(speedupThemeName) || speedupCopyLoading ? <Text variant="bodyMd" as="p">{t("Theme Duplicated Via SEOWILL")}</Text> : null
                                }
                                {
                                    Boolean(speedupThemeName) ? <TextField
                                        value={speedupThemeName || ""}
                                        onChange={() => { }}
                                        disabled
                                    /> : speedupCopyLoading ? <div style={{ margin: '5px 0 0', maxWidth: "240px" }}>
                                        <SkeletonBodyText lines={2} />
                                    </div> : null
                                }
                            </div>
                        </div> : <div className="speedup_theme_modal">
                            <Text variant="bodyMd" as="p">{t("Speed optimization will modify theme's code. Please test on an duplicated theme first, and publish the theme only after confirming everything works well.")}</Text>
                            <div className="speedup_theme_select">
                                <div className={`manual_select theme_select_block ${themeSelect === 'manual' ? 'active' : ''}`} onClick={() => this.handleSelectThemeMode('manual')}>
                                    <BlockStack gap={200}>
                                        <ChoiceList
                                            title=""
                                            choices={[
                                                {
                                                    label: <div className="flex_layout">
                                                        <p>{t("Duplicate a New Theme")}</p>
                                                        <Badge tone="info">{t("Recommended")}</Badge>
                                                    </div>, value: 'manual'
                                                },
                                            ]}
                                            disabled={btnCopySupLoading}
                                            selected={themeSelect}
                                            onChange={() => { }}
                                        />
                                        {
                                            Boolean(speedupThemeName) ? <div className="via_theme_block">
                                                <TextField
                                                    value={speedupThemeName || ""}
                                                    onChange={() => { }}
                                                    disabled
                                                />
                                            </div> : speedupCopyLoading ? <SkeletonBodyText lines={2} /> : null
                                        }
                                    </BlockStack>
                                    {
                                        themeSelect === 'manual' ? <div className="img_process" onClick={() => this.openViewImage("/imgs/speedup/speed_dup.gif")}>
                                            <img className="dup_gif" src="/imgs/speedup/speed_dup.gif" alt="" />
                                        </div> : null
                                    }
                                </div>
                                <div className={`created_select theme_select_block ${themeSelect === 'created' ? 'active' : ''}`} onClick={() => this.handleSelectThemeMode('created')}>
                                    <BlockStack gap={400}>
                                        <ChoiceList
                                            title=""
                                            choices={[
                                                { label: t("Select the Theme Duplicated via SEOWILL"), value: 'created' },
                                            ]}
                                            disabled={btnCopySupLoading}
                                            selected={themeSelect}
                                            onChange={() => { }}
                                        />
                                        {
                                            themeSelect === 'created' ? <Popover
                                                active={isShowThemeSelectPop}
                                                activator={
                                                    <div className="theme_select_pop_activator" onClick={this.toggleThemeSelectPop}>
                                                        <TextField
                                                            label=""
                                                            value={themeSelectName}
                                                            onChange={() => { }}
                                                            placeholder={t("Select the theme duplicated via SEOWILL")}
                                                            suffix={<Icon source={SelectIcon} />}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                }
                                                fullWidth={true}
                                                preferredAlignment={"left"}
                                                onClose={this.toggleThemeSelectPop}
                                            >
                                                <div className="theme_select_pop_content">
                                                    <TextField
                                                        label=""
                                                        value={themeSelectSearch}
                                                        onChange={this.handleSearchThemeSelect}
                                                        placeholder={t("Search the theme duplicated via SEOWILL")}
                                                        prefix={<Icon source={SearchIcon} />}
                                                        autoComplete="off"
                                                    />
                                                </div>
                                                <div className="theme_select_pop_content_list">
                                                    {
                                                        copyThemeListData.length > 0 ? <ActionList
                                                            actionRole="menuitem"
                                                            items={
                                                                copyThemeListData.map(item => {
                                                                    return {
                                                                        active: selectThemeId === item.theme_id,
                                                                        content: item.role === "main" ? <Tooltip content={<div>
                                                                            <span>{t("This theme is published. To avoid affecting your live store, please")} <span>{t("duplicate")}</span> {t("it and optimize the copy.")}</span>
                                                                        </div>}>
                                                                            <span>{item.name}</span>&nbsp;&nbsp;
                                                                            {
                                                                                Boolean(item.role === "main") ? <Badge tone="success">{t("Current theme")}</Badge> : null
                                                                            }
                                                                        </Tooltip> : <p>
                                                                            <span>{item.name}</span>&nbsp;&nbsp;
                                                                            {
                                                                                Boolean(item.role === "main") ? <Badge tone="success">{t("Current theme")}</Badge> : null
                                                                            }
                                                                        </p>,
                                                                        disabled: item.role === "main",
                                                                        helpText: `${t("Added")}: ${formatTimestamp(item.created_at * 1000)}`,
                                                                        suffix: selectThemeId === item.theme_id ? checkIcon : null,
                                                                        onAction: () => this.handleSelectTheme(item.theme_id, item.is_del),
                                                                    }
                                                                })
                                                            }
                                                        /> : <div className="theme_select_pop_content_list_empty">
                                                            <Text variant="bodyMd" as="p">{t("No theme found")}</Text>
                                                        </div>
                                                    }
                                                </div>
                                            </Popover> : null
                                        }
                                    </BlockStack>
                                </div>
                            </div>
                        </div>
                    }
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 加速进度模块
        const speedupProgressModule = <div className="speedup_progress_module" style={{ display: isShowProgressModule ? 'block' : 'none' }}>
            <Card padding={0}>
                <div className="speedup_progress_module_header" onClick={this.toggleSpeedupProgressModule}>
                    <Text variant="headingMd" as="h2">{t("Speed Up in Progress")}</Text>
                    <Text variant="headingMd" as="p">{t("{{v1}}/{{v2}} tasks", taskCpl, taskAll)}</Text>
                    <Icon source={isShowProgress ? ChevronUpIcon : ChevronDownIcon} />
                </div>
                <Collapsible
                    id="SiteSpeedup-progress-collapsible"
                    open={isShowProgress}
                    transition={{ duration: '300ms' }}
                    expandOnPrint
                >
                    <div className="speedup_progress_module_content">
                        <div className="speedup_progress_module_content_main">
                            <img src="/imgs/speedup/progress.gif" alt="" />
                            <div className="speedup_progress_module_object">
                                {
                                    animateList.length > 0 ? animateList.map((item, aIndex) => {
                                        return <div className={`speedup_progress_module_object_item speedup_task ${item.tStatus === 1 ? 's_completed' : ''} ${aIndex >= animateList.length - 2 ? 's_completed_noani' : ''}`} key={item.id}>
                                            <div className="speedup_progress_info">
                                                <Text variant="bodySm" as="p">{t(item.do)}</Text>
                                                <span>{item.pStatus === 1 ? "" : item.pStatus === 2 ? t("Accelerating") + ".." : item.pStatus === 3 ? t("Waiting") + ".." : ""}</span>
                                                <div className="speedup_progress_module_object_item_percent">
                                                    {
                                                        item.pStatus === 1 ? <div>
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM12.9648 7.97754C12.7519 7.76507 12.4073 7.7651 12.1943 7.97754L9.30664 10.8652L8.05566 9.61426C7.8427 9.40158 7.4981 9.40155 7.28516 9.61426C7.07214 9.82727 7.07214 10.1727 7.28516 10.3857L8.9209 12.0225C9.13383 12.2353 9.47938 12.2352 9.69238 12.0225L12.9648 8.74902C13.1779 8.53601 13.1779 8.19055 12.9648 7.97754Z" fill="#29845A" />
                                                            </svg>
                                                        </div> : item.title === "read_all_files" ? `${item.SupStatus === 1 ? 100 : readFileNum.current === 0 ? 1 : ((readFileNum.current / readFileNum.all) * 100).toFixed(0)}%` : "0%"
                                                    }
                                                </div>
                                            </div>
                                            <ProgressBar tone="primary" progress={item.title === "read_all_files" ? (item.SupStatus === 1 ? 100 : readFileNum.current === 0 ? 1 : (readFileNum.current / readFileNum.all) * 100).toFixed(0) : item.pStatus === 1 ? 100 : 0} size="small" />
                                        </div>
                                    }) : <BlockStack gap={400}>
                                        <SkeletonBodyText lines={2} />
                                        <SkeletonBodyText lines={2} />
                                    </BlockStack>
                                }
                            </div>
                        </div>
                    </div>
                </Collapsible>
            </Card>
        </div>

        // 加速主题记录
        const speedupRecordList = acceleratedThemeList.length > 0 ? <Card padding={0}>
            <div className="speedup_theme_record_list_box">
                <div className="speedup_theme_record_list_header">
                    <Text variant="headingMd" as="h2">{t("Theme Optimization History")}</Text>
                    <Text variant="bodyMd" tone="subdued" as="p">
                        {t("Click Preview to check your accelerated theme, then publish to speed up your site.")}
                    </Text>
                </div>
                <div className="speedup_theme_record_list">
                    {optListLoading ? <div className="table_loading"><Spinner /></div> : acceleratedThemeList.length > 0 ? acceleratedThemeList.map((theme, index) => {
                        const isCurrentTheme = Number(theme.theme_id) === Number(currentThemeId);
                        const isPublished = theme.role === "main" || isCurrentTheme;
                        return (
                            <div key={theme.theme_id} className="speedup_theme_record_item" style={{ display: (index <= 2 || (isMore && index > 2)) ? 'flex' : 'none' }}>
                                <div className="theme_record_thumbnail">
                                    <img
                                        src={theme.preview_image || "/imgs/speedup/theme_img.png"}
                                        alt={theme.name}
                                        onError={(e) => {
                                            e.target.src = "/imgs/speedup/theme_img.png";
                                        }}
                                    />
                                </div>

                                <div className="theme_record_info">
                                    <BlockStack>
                                        <div className="theme_record_header">
                                            <Text variant="headingSm" as="h3" fontWeight="bold">{theme.name}</Text>
                                            <Badge tone={isPublished ? "success" : ""}>
                                                {isPublished ? t("Current theme") : t("Unpublish")}
                                            </Badge>
                                        </div>

                                        <div className="theme_record_meta">
                                            <div className="theme_record_mode">
                                                <Text variant="bodySm" as="span">{t("Accelerated Mode")}: </Text>
                                                {/* 加速模式 1：basic  2：rocket  3：turbo */}
                                                <Badge tone="info">
                                                    {Number(theme?.accelerate_mode) === 1 ? t("Basic") : Number(theme?.accelerate_mode) === 2 ? t("Rocket") : t("Turbo")}
                                                </Badge>
                                            </div>
                                        </div>

                                        <Text variant="bodySm" tone="subdued" as="p">
                                            {t("Last Optimization Time")}: {theme?.last_opt_at ? formatTimestamp(theme.last_opt_at * 1000, true) : "-"}
                                        </Text>
                                    </BlockStack>
                                </div>

                                <div className="theme_record_actions">
                                    <Popover
                                        active={moreSelectId === theme.theme_id}
                                        activator={
                                            <Button icon={MenuHorizontalIcon} disabled={isAllBtnFalse || Boolean(selectThemeId && selectThemeId !== -1 && !isShowSpeedupThemeModal)} loading={(selectThemeId === theme.theme_id) && !isShowSpeedupThemeModal} onClick={() => this.handleMoreFuncSelect(theme.theme_id)} />
                                        }
                                        preferredAlignment={"right"}
                                        onClose={() => this.handleMoreFuncSelect(-1)}
                                    >
                                        <ActionList
                                            actionRole="menuitem"
                                            items={[
                                                {
                                                    content: theme.role === "main" ? <Tooltip content={<div>
                                                        <span>{t("This theme is published. To avoid affecting your live store, please")} <Link onClick={() => this.handleChangeSpeedThemeModal(true)}>{t("duplicate")}</Link> {t("it and optimize the copy.")}</span>
                                                    </div>}>
                                                        <span>{t("Speed Up")}</span>
                                                    </Tooltip> : t("Speed Up"),
                                                    disabled: theme.role === "main",
                                                    onAction: () => this.handleSpeedUpTheme(theme.theme_id),
                                                },
                                                {
                                                    content: t("Remove from history"),
                                                    onAction: () => this.handleRemoveRecord(theme.theme_id),
                                                },
                                            ]}
                                        />
                                    </Popover>
                                    {isPublished ? (
                                        <Button variant="primary" onClick={() => {
                                            window.open(`https://${domain}/?_ab=0&_fd=0&_sc=1&preview_theme_id=${theme.theme_id}`)
                                        }}>
                                            {t("Preview")}
                                        </Button>
                                    ) : (
                                        <>

                                            <Button onClick={() => {
                                                window.open(`https://${domain}/?_ab=0&_fd=0&_sc=1&preview_theme_id=${theme.theme_id}`)
                                            }}>
                                                {t("Preview")}
                                            </Button>
                                            <Button disabled={(publicBtnLoading && publicBtnLoading !== theme.theme_id) || isAllBtnFalse} loading={publicBtnLoading === theme.theme_id} onClick={() => this.publishThemeData(1, theme.theme_id)}>
                                                {t("Publish")}
                                            </Button>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    }) : (
                        <div className="speedup_theme_record_empty">
                            <Text variant="bodyMd" tone="subdued" as="p">
                                {t("No accelerated themes found")}
                            </Text>
                        </div>
                    )}
                </div>
                {(acceleratedThemeList.length > 3 && !optListLoading) && (
                    <div className="speedup_theme_record_more" onClick={() => this.setState({ isMore: !isMore })}>
                        <span>{isMore ? t("Less") : t("More")}</span>
                        <Icon source={isMore ? ChevronUpIcon : ChevronDownIcon} />
                    </div>
                )}
            </div>
        </Card> : null

        // 加速确认弹窗
        const speedupConfirmModal = <Modal
            open={isShowConfirmModal}
            title={t("Speed up confirmation")}
            primaryAction={
                {
                    content: t("Save & Speed Up"),
                    onAction: this.handleUpdSpeedSetting,
                    loading: isOnlySpeedLoading,
                }
            }
            secondaryActions={[
                {
                    content: t("Cancel"),
                    disabled: isOnlySpeedLoading,
                    onAction: () => this.toggleComfirmModal(false),
                }
            ]}
            onClose={() => this.toggleComfirmModal(false)}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    <div className="speedup_available_features">
                        <BlockStack gap={200}>
                            <Text variant="headingMd" as="h2">{t("Available Features")}</Text>
                            <div className="sucm_main">
                                {
                                    serversList.map((item) => {
                                        return item.plan > level ? null : <div key={item.id} className="sucm_items">
                                            <div className="sucm_items_main">
                                                <div className="sucm_title">
                                                    <Tooltip
                                                        width={'wide'}
                                                        content={
                                                            <div className="pricing_desc_img">
                                                                <img src={item?.image} alt='' />
                                                                <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                <span>{t(item?.desc)}</span>
                                                            </div>
                                                        }
                                                    >
                                                        <p className="sucm_title_answer">
                                                            {t(item.name)}
                                                        </p>
                                                    </Tooltip>
                                                </div>
                                                <div className="custome_switch flex_layout">
                                                    <Switch disabled={isOnlySpeedLoading} onChange={() => this.handleChangeModalSwitch(item, true, false)} checked={Boolean(item.status)} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </BlockStack>
                    </div>
                    {
                        level === 3 ? null : <div className="speedup_unlock_more">
                            <BlockStack gap={200}>
                                <div className="flex_layout speedup_unlock_more_title">
                                    <Text variant="headingMd" as="h2">{t("Unlock More")}</Text>
                                    <span className="upgrade_btn flex_layout" onClick={this.handleUpgradeMore}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM10.5303 5.96973C10.2374 5.67683 9.76262 5.67683 9.46973 5.96973L6.96973 8.46973C6.67683 8.76262 6.67683 9.23738 6.96973 9.53027C7.26262 9.82317 7.73738 9.82317 8.03027 9.53027L9.25 8.31055V13.5C9.25 13.9142 9.58579 14.25 10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V8.31055L11.9697 9.53027C12.2626 9.82317 12.7374 9.82317 13.0303 9.53027C13.3232 9.23738 13.3232 8.76262 13.0303 8.46973L10.5303 5.96973Z" fill="var(--color-primary)" />
                                        </svg>
                                    </span>
                                </div>
                                <div className="sucm_main">
                                    {
                                        serversList.map((item) => {
                                            return item.plan <= level ? null : <div key={item.id} className="sucm_items">
                                                <div className="sucm_items_main">
                                                    <div className="sucm_title">
                                                        <Tooltip
                                                            width={'wide'}
                                                            content={
                                                                <div className="pricing_desc_img">
                                                                    <img src={item?.image} alt='' />
                                                                    <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                    <span>{t(item?.desc)}</span>
                                                                </div>
                                                            }
                                                        >
                                                            <p className="sucm_title_answer">
                                                                {t(item.name)}
                                                            </p>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="custome_switch flex_layout">
                                                        <Switch disabled={isOnlySpeedLoading || true} onChange={() => this.handleChangeModalSwitch(item, true, false)} checked={false} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </BlockStack>
                        </div>
                    }
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 加速完成提示banner
        const checkSucIcon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4215_56721)">
                <path d="M4.5 9L7.5 12L13.5 6" stroke="#29845A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4215_56721">
                    <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="white" />
                </clipPath>
            </defs>
        </svg>
        const completeModal = <Modal
            open={isShowCompleteModal}
            title={t("Acceleration finished!🎉 Preview your theme now.")}
            primaryAction={
                {
                    content: t("Preview Theme"),
                    onAction: () => {
                        window.open(`https://${domain}/?_ab=0&_fd=0&_sc=1&preview_theme_id=${operaThemeId}`)
                    }
                }
            }
            onClose={this.setSupCompleteModal}
        >
            <Modal.Section>
                <div className="complete_modal_content">
                    <div className="complete_modal_content_img">
                        <img src="/imgs/speedup/completed.gif" alt="" />
                    </div>
                    <Text variant="headingMd" as="h2">{t("Before publishing, please preview the theme to ensure everything works perfectly")}</Text>
                    <ul>
                        <li>{checkSucIcon} {t("Design & Layout — Check that fonts, colors, and layouts remain consistent after optimization.")}</li>
                        <li>{checkSucIcon} {t("Navigation — Test all menus, dropdowns, and links to confirm they work properly.")}</li>
                        <li>{checkSucIcon} {t("Interactive Elements — Ensure buttons, forms, sliders, and pop-ups function as expected.")}</li>
                        <li>{checkSucIcon} {t("Media — Verify that all images and videos load correctly.")}</li>
                        <li>{checkSucIcon} {t("User Experience — Go through key flows like login, registration, and checkout to confirm everything runs smoothly.")}</li>
                    </ul>
                </div>
            </Modal.Section>
        </Modal>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />
        // 主内容
        const pageMain = loadingPage ? <SkeltonLoading /> : <Page>
            <BlockStack gap={400}>
                {bannerSite === 'top' && errorBannerBox}
                <div className="sm_top_action">
                    <div className="left_score">
                        <Card>
                            <div className="score_performance_block">
                                <div className="score_performance_top">
                                    <Text variant="headingMd" as="h2">{t("PageSpeed Score")}</Text>
                                    <div className='performance_tab'>
                                        <div onClick={() => this.handleSetPerformanceTab('pc')} className={`performance_tab_pc ${performanceTab === 'pc' ? 'active' : ''}`}><Icon source={DesktopIcon} tone='base' /></div>
                                        <div onClick={() => this.handleSetPerformanceTab('mb')} className={`performance_tab_mb ${performanceTab === 'mb' ? 'active' : ''}`}><Icon source={MobileIcon} tone='base' /></div>
                                    </div>
                                </div>
                                <BlockStack gap={800}>
                                    <InstrumentPanel
                                        isPwd={isPwd}
                                        isSpeed={true}
                                        speedType={performanceTab}
                                        svgHeight={140}
                                        strokeDash={performanceTab === 'pc' ? scoreObj.after_pc : scoreObj.after_mb}
                                        strokeWidth={12}
                                        smallSize={0.3}
                                        loading={RecheckButtonLoading}
                                        isShowRecheck={true}
                                        onRecheck={this.handleRecheckPerformance}
                                    />
                                    <BlockStack gap={200}>
                                        <p className="score_performance_info flex_layout">
                                            {
                                                RecheckButtonLoading ? t("--") : <>
                                                    {t("Your web performance")}&nbsp;
                                                    {
                                                        ((performanceTab === 'pc' && scoreObj.after_pc >= 90) || (performanceTab === 'mb' && scoreObj.after_pc >= 70)) ? t("is good") : 2 ? t("need Improvement") : t("is poor")
                                                    }
                                                </>
                                            }
                                            <Tooltip content={<>
                                                <span>{t("This score comes from Google PageSpeed Insights. Scores may fluctuate due to Google's test conditions. Temporary drops are normal.")}</span>
                                                &nbsp;
                                                <Link removeUnderline external url="https://developer.chrome.com/docs/lighthouse/performance/performance-scoring">{t("Learn more")}.</Link>
                                            </>}>
                                                <Icon source={QuestionCircleIcon} />
                                            </Tooltip>
                                        </p>
                                        <Button variant="plain" onClick={() => {
                                            window.open(`https://pagespeed.web.dev/report?url=https://${domain}`, '_blank');
                                        }}>
                                            <div className="flex_layout">
                                                <span>{t("Detailed Report")}</span>
                                                <Icon source={ArrowRightIcon} />
                                            </div>
                                        </Button>
                                    </BlockStack>
                                </BlockStack>
                            </div>
                        </Card>
                    </div>
                    <div className="right_mode">
                        <Card>
                            <div className="flex_layout speedup_top">
                                {/* <Text variant="headingMd" as="h2">{t("Speed up plan")}</Text> */}
                                <Button variant="plain" onClick={this.toggleCompareModal}>{t("Compare Modes")}</Button>
                            </div>
                            <div className="speedup_main">
                                <div className="sm_select sm_items">
                                    <BlockStack gap={200}>
                                        <div className="sm_img">
                                            <div onClick={() => this.changePlanId(1)}><Icon source={SpeedBasicIcon} /></div>
                                            <div onClick={() => this.changePlanId(2)}><Icon source={SpeedFastIcon} /></div>
                                            <div onClick={() => this.changePlanId(3)}><Icon source={SpeedRocketIcon} /></div>
                                        </div>
                                        <BlockStack gap={100}>
                                            <div className="sm_progress">
                                                <div className="p_line"></div>
                                                <div onClick={(e) => this.changePlanId(1, e)} className="p_line_transparent"></div>
                                                <div className="p_line_active" style={{
                                                    width: `calc(${(planId - 1) * 50}% - ${(planId - 1) * 10}px)`
                                                }}></div>
                                                <span className="rocket_icon" style={{ left: `calc(${(planId - 1) * 50}% - ${(planId - 1) * 10}px - 12px)` }}>
                                                    {RocketIcon}
                                                    <span>X{planId === 1 ? 1 : planId === 2 ? 2 : 4}</span>
                                                </span>
                                                <p onClick={() => this.changePlanId(1)} className={`p_points ${planId >= 1 ? "p_active" : ""}`}></p>
                                                <p onClick={() => this.changePlanId(2)} className={`p_points ${planId >= 2 ? "p_active" : ""}`}></p>
                                                <p onClick={() => this.changePlanId(3)} className={`p_points ${planId === 3 ? "p_active" : ""}`}></p>
                                            </div>
                                            <div className="sm_text">
                                                <div className="t_name" onClick={() => this.changePlanId(1)}>
                                                    <p className={`${planId === 1 ? 't_active' : ''}`}>{t("Basic")}  {level === 1 && <span>({t("Current plan")})</span>}</p>
                                                </div>
                                                <div className="t_name">
                                                    <p onClick={() => this.changePlanId(2)} className={`${planId === 2 ? 't_active' : ''}`}>{t("Rocket")} {level === 2 && <span>({t("Current plan")})</span>}</p>
                                                </div>
                                                <div className="t_name" >
                                                    <p onClick={() => this.changePlanId(3)} className={`${planId === 3 ? 't_active' : ''}`}>{t("Turbo")} {level === 3 && <span>({t("Current plan")})</span>}</p>
                                                </div>
                                            </div>
                                        </BlockStack>
                                    </BlockStack>
                                </div>
                                <div className="sm_setting sm_items">
                                    {/* 三角形 */}
                                    <div className="triangle_mode">
                                        <svg style={{ left: planId === 1 ? 28 : planId === 2 ? 'calc(50% - 10px)' : 'calc(100% - 50px)' }} width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.9185 17.5H0.865723L10.3921 0.999023L19.9185 17.5Z" fill="#F7F7F7" stroke="url(#paint0_linear_952_17464)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_952_17464" x1="10.3921" y1="0" x2="10.3921" y2="17.5" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#E3E3E3" />
                                                    <stop offset="0.668305" stopColor="#E3E3E3" />
                                                    <stop offset="0.779569" stopColor="#F7F7F7" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>

                                    <BlockStack gap={100}>
                                        <div className="flex_layout">
                                            <Text variant="headingMd" as="h3">{t("How It Speed Up")}: </Text>
                                        </div>
                                        <div className="sm_wedo">
                                            <p className="sm_do_items"
                                                onMouseEnter={this.handleRightMouseEnter}
                                                onMouseLeave={this.handleRightMouseLeave}
                                            >
                                                {
                                                    planId === 1 ? <Tooltip
                                                        width={'wide'}
                                                        content={
                                                            <div className="pricing_desc_img">
                                                                <img src={popList["Instant Page Load"].img} alt='' />
                                                                <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                <span>{t(popList["Instant Page Load"].desc)}</span>
                                                            </div>
                                                        }
                                                    >
                                                        <span className="sucm_title_answer">
                                                            {t("Instant Page Load")}
                                                        </span>
                                                    </Tooltip> : planId === 2 ?
                                                        ["Instant Page Load", "Lazy Load Images", "Defer External Script"].map((item, index) => {
                                                            return <Tooltip
                                                                key={`${item}`}
                                                                width={'wide'}
                                                                content={
                                                                    <div className="pricing_desc_img">
                                                                        <img src={popList[item].img} alt='' />
                                                                        <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                        <span>{t(popList[item].desc)}</span>
                                                                    </div>
                                                                }
                                                            >
                                                                <span className="sucm_title_answer">
                                                                    {t(item)} {index < 2 ? '、' : ''}
                                                                </span>
                                                            </Tooltip>
                                                        }) : planId === 3 ? ["Critical CSS Loading", "Asset File Compression", "Code Optimization"].map((item, index) => {
                                                            return <Tooltip
                                                                key={`${item}`}
                                                                width={'wide'}
                                                                content={
                                                                    <div className="pricing_desc_img">
                                                                        <img src={popList[item].img} alt='' />
                                                                        <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                        <span>{t(popList[item].desc)}</span>
                                                                    </div>
                                                                }
                                                            >
                                                                <span className="sucm_title_answer">
                                                                    {t(item)} {index < 2 ? '、' : ''}
                                                                </span>
                                                            </Tooltip>
                                                        }) : "-"
                                                }
                                            </p>&nbsp;&nbsp;
                                            {
                                                planId === 3 ? <Button disabled={isAllBtnFalse} variant="plain" onClick={() => this.toggleComfirmModal(true)}>{t("and {{v1}} more.", 4)}</Button> : null
                                            }
                                        </div>
                                        <div className="sm_action flex_layout">
                                            <Button icon={SettingsIcon} disabled={isAllBtnFalse || isFakeBtnLoading || selectThemeId !== -1} loading={reduxLoading} onClick={() => this.toggleComfirmModal(true)}>{t("Speed Up Settings")}</Button>
                                            <Button variant="primary" disabled={isAllBtnFalse || reduxLoading} loading={isAllBtnFalse || isFakeBtnLoading || selectThemeId !== -1} onClick={() => {
                                                if (planId <= level) {
                                                    this.handleChangeSpeedThemeModal(true)
                                                } else {
                                                    this.props.upgradeModal(planId === 2 ? 1 : 2, planId === 2 ? 'SpeedUpPro' : 'SpeedUpPre', 'speed_up');
                                                }
                                            }}>
                                                <div className="flex_layout" style={{ gap: '2px' }}>
                                                    {t("Speed Up Now")}
                                                    {
                                                        planId <= level ? null : <span className="flex_layout">
                                                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11 3C14.866 3 18 6.13401 18 10C18 13.866 14.866 17 11 17C7.13401 17 4 13.866 4 10C4 6.13401 7.13401 3 11 3Z" fill="var(--color-primary)" />
                                                                <path d="M11.75 13.5C11.75 13.9142 11.4142 14.25 11 14.25C10.5858 14.25 10.25 13.9142 10.25 13.5V8.31066L9.03033 9.53033C8.73744 9.82322 8.26256 9.82322 7.96967 9.53033C7.67678 9.23744 7.67678 8.76256 7.96967 8.46967L10.4697 5.96967C10.7626 5.67678 11.2374 5.67678 11.5303 5.96967L14.0303 8.46967C14.3232 8.76256 14.3232 9.23744 14.0303 9.53033C13.7374 9.82322 13.2626 9.82322 12.9697 9.53033L11.75 8.31066V13.5Z" fill="white" />
                                                                <defs>
                                                                    <linearGradient id="paint0_linear_3170_85753" x1="18" y1="17" x2="4" y2="4" gradientUnits="userSpaceOnUse">
                                                                        <stop stopColor="#8A36FF" />
                                                                        <stop offset="1" stopColor="#FF49E7" />
                                                                    </linearGradient>
                                                                </defs>
                                                            </svg>
                                                        </span>
                                                    }
                                                </div>
                                            </Button>
                                            {
                                                (isShowSecTip && isGuideTip) && <div className={`sec_tip popover_tip ${isShowPop ? "showPop" : ""}`}>
                                                    <div className="pop_main">
                                                        <div className="pop_child">
                                                            <p>{t("Click to speed up your store")}</p>
                                                            <div><Button variant="primary" onClick={() => this.toggleComfirmModal(true)}>{t("Got it")}</Button></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </BlockStack>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                {speedupProgressModule}
                {speedupRecordList}
            </BlockStack>
            {FooterHelpBox}
        </Page>

        // 最终页面
        const pageContent = <div id="SiteSpeedup">
            <title>SEOWILL - Site Speed Up</title>

            {pageMain}
            {comparePlanModal}
            {completeModal}
            {speedupThemeModal}
            {speedupConfirmModal}
            {celebrateModal}
            {removeRecordConfirmModal}
            {
                Boolean(imgUrl) && <ViewImage imgUrl={imgUrl} closeImageShow={this.closeImageShow} />
            }
        </div>;

        return pageContent;
    }
}

// 时间格式
function formatTimestamp(timestamp, isYear = false) {
    const now = new Date();
    const date = new Date(timestamp);
    const timeDiff = (now - date) / 1000; // 计算时间差（秒）
    const minutesDiff = Math.floor(timeDiff / 60);
    const hoursDiff = Math.floor(timeDiff / 3600);
    // 如果时间差小于1小时，返回"xx minutes ago"
    if (hoursDiff < 1) {
        return minutesDiff <= 0 ? 'just now' : `${minutesDiff} minutes ago`;
    }
    // 如果时间大于1小时，返回日期和时间
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12; // 转换为12小时制
    let timeText = isYear ? `${t(month)} ${day}, ${year} ${hours}:${minutes} ${ampm}` : `${t(month)} ${day} at ${hours}:${minutes} ${ampm}`;
    return timeText;
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['SiteSpeedUp', data]));
    },
})

SiteSpeedup = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SiteSpeedup);

export default withRouter(SiteSpeedup);
